import { FC } from "react";
import { useTranslation } from "next-i18next";
import { Area } from "@prisma/client";

import SortFilter from "./filters/sort-filter";
import GridFilter from "./filters/grid-filter";
import PriceFilter from "./filters/price-filter";
// import MeasuresFilter from "./filters/measures-filter";
import FiltersFooter from "./filters/filters-footer";

import FiltersContextProvider from "@context/filter";
import { ActionType, Filters, Measures } from "@interfaces/filters";
import { Facets } from "@interfaces/utility";

interface Props {
  filters?: Partial<Filters>;
  facets?: Facets;
  ranges?: Measures;
  totalNumberOfProducts: number;
  areaData: Area[];
}

const FiltersComponent: FC<Props> = ({
  filters,
  totalNumberOfProducts,
  facets,
  ranges,
  areaData,
}) => {
  const { t } = useTranslation("category");

  return filters && facets && ranges ? (
    <FiltersContextProvider {...{ ...filters, totalNumberOfProducts }}>
      <div className="space-y-3 z-30 pb-4">
        <div className="flex flex-row flex-wrap justify-center items-center mx-auto">
          <SortFilter />

          {/* {facets["supplier"] && Object.keys(facets["supplier"]).length > 0 && (
            <GridFilter
              {...{
                type: ActionType.SET_SUPPLIER,
                entries: facets["supplier"],
                filterName: t("filters.supplier.label"),
                check: true,
              }}
              className="-translate-x-1/4 z-30"
            />
          )} */}

          {/* {facets["color"] && facets["color"].length > 0 && (
            <GridFilter
              {...{
                type: ActionType.SET_COLOR,
                entries: facets["color"],
                filterName: "Boja",
              }}
              className="-translate-x-1/4 z-30"
            />
          )} */}

          {/* {facets["material"] && Object.keys(facets["material"]).length > 0 && (
            <GridFilter
              {...{
                type: ActionType.SET_MATERIAL,
                entries: facets["material"],
                filterName: t("filters.material.label"),
                check: true,
              }}
              className="-translate-x-1/3 z-30"
            />
          )} */}

          {/* {facets["style"] && facets["style"].length > 0 && (
            <GridFilter
              {...{
                type: ActionType.SET_STYLE,
                entries: facets["style"],
                filterName: "Stil",
                check: true,
              }}
              className="-translate-x-1/2 z-30"
            />
          )} */}

          {facets["area"] && Object.keys(facets["area"]).length > 0 && (
            <GridFilter
              {...{
                type: ActionType.SET_AREA,
                entries: facets["area"],
                filterName: t("filters.area.label"),
                check: true,
              }}
              className="-translate-x-2/3 z-30"
            />
          )}

          <PriceFilter
            {...{ range: ranges.price }}
            className="-translate-x-1/4 z-30"
          />

          {/* <MeasuresFilter {...{ ranges }} className="-translate-x-1/3 z-30" /> */}
        </div>

        <FiltersFooter {...{ areaData }} />
      </div>
    </FiltersContextProvider>
  ) : null;
};

export default FiltersComponent;
